import {Component} from '@angular/core';

import {ParametersService, SubtitlesService} from "../core";

@Component({
    selector: 'inactive-module',
    templateUrl: './inactive-module.component.html',
    styleUrls: ['./inactive-module.component.scss']
})
export class InactiveModuleComponent {
    constructor(
        public parameters: ParametersService,
        public subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number) {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    hasModules(): boolean {
        return this.parameters.modules.length !== 0
    }
}
